import "./styles.less";

const AdornItem = (props) => {
  const {

    title = "",
    content = "",
    width=''
  } = props;

  return (
    <div className="cube" style={{width}}>
      <div className="adorn">///////////</div>
      <h5>{title}</h5>
      <div className="matter">{content}</div>
    </div>
  );
};
export default AdornItem;
